export const GameTypeEnum = {
  Prematch: 0,
  Live: 1,
  FutureLive: 2,
};

export const GameTypeViewEnum = {
  [GameTypeEnum.FutureLive]: 'prematch',
  [GameTypeEnum.Live]: 'live',
  [GameTypeEnum.Prematch]: 'prematch',
};
